var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPortfolio = function SvgPortfolio(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.3851 11.3848H14.4621C14.1222 11.3848 13.8467 11.6603 13.8467 12.0002V19.3848C13.8467 19.7246 14.1222 20.0001 14.4621 20.0001H19.3851C19.725 20.0001 20.0005 19.7246 20.0005 19.3848V12.0002C20.0005 11.6603 19.725 11.3848 19.3851 11.3848Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3851 4H14.4621C14.1222 4 13.8467 4.27552 13.8467 4.61538V7.08923C13.8467 7.4291 14.1222 7.70462 14.4621 7.70462H19.3851C19.725 7.70462 20.0005 7.4291 20.0005 7.08923V4.61538C20.0005 4.27552 19.725 4 19.3851 4Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.53846 4H4.61538C4.27552 4 4 4.27552 4 4.61538V12C4 12.3399 4.27552 12.6154 4.61538 12.6154H9.53846C9.87833 12.6154 10.1538 12.3399 10.1538 12V4.61538C10.1538 4.27552 9.87833 4 9.53846 4Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.53846 16.2955H4.61538C4.27552 16.2955 4 16.571 4 16.9109V19.3847C4 19.7246 4.27552 20.0001 4.61538 20.0001H9.53846C9.87833 20.0001 10.1538 19.7246 10.1538 19.3847V16.9109C10.1538 16.571 9.87833 16.2955 9.53846 16.2955Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgPortfolio;